export default "__VITE_ASSET__d74aa1c9__"